import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import useLocales from '#/hooks/useLocales';

type Props = {
  children: React.ReactNode;
  changeAnswer?: () => void;
  isComplexForm?: boolean;
};

export default function ActionButtons({
  changeAnswer,
  children,
  isComplexForm = false,
}: Props) {
  const { translate } = useLocales();

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
      {isComplexForm && (
        <Button variant="outlined" onClick={changeAnswer}>
          <Typography variant="body2">
            {String(translate('lastWill.stepFour.stopProcess.changeAnswerBtn'))}
          </Typography>
        </Button>
      )}
      {children}
    </Stack>
  );
}
